import { useState, useRef, useEffect, useCallback } from 'react'
import intervalToDuration from 'date-fns/intervalToDuration'

const TimerDays = ({ date, className, timeIsOver }) => {
  const [timer, setTimer] = useState('')

  const intervalRef = useRef(null)

  const format = (start, end) => {
    const duration = intervalToDuration({
      start: start,
      end: end
    })

    const zero = (number) => String(number).padStart(2, 0)

    if (duration.days === 0)
      return `${zero(duration.hours)}:${zero(duration.minutes)}:${zero(duration.seconds)}`
    else
      return `${duration.days}д ${zero(duration.hours)}:${zero(duration.minutes)}:${zero(duration.seconds)}`
  }

  const setTime = useCallback(() => {
    const now = new Date()
    const userTimezoneOffset = date.getTimezoneOffset() * 60000

    const newDate = new Date(date.getTime() - userTimezoneOffset)

    if (newDate < now) {
      timeIsOver()

      clearTimeout(intervalRef.current)

      return
    }

    setTimer(format(now, newDate))
  }, [date, timeIsOver])

  useEffect(() => {
    if (!timer) {
      setTime()
    }

    intervalRef.current = setTimeout(() => {
      setTime()
    }, 1000)

    return () => clearTimeout(intervalRef.current)
  }, [date, timer, setTime])

  return (
    <p className={`flex leading-[24px] text-[17px] text-white ${className || ''}`}>
      <svg
        width="24"
        height="24"
        className="mr-[7px]"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM15.29 16.71L11 12.41V7H13V11.59L16.71 15.3L15.29 16.71Z"
          fill="white"
        />
      </svg>
      {timer}
    </p>
  )
}

export default TimerDays
